webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





var colors = {
    contributing: ['#c4cddf', '#99afd9', '#6582ba', '#2a4b8d'],
    reading: ['#c8f0e7', '#77d8c2', '#00af89', '#03745c'],
    content: ['#fff1c6', '#f9df90', '#ffcc33', '#ddad1c']
};
var stableColorIndexes = {
    'Lightly Active': 0,
    'Active': 1,
    'Very Active': 2
};

var lightColor = {
    contributing: colors.contributing[0],
    reading: colors.reading[0],
    content: colors.content[1]
};
var darkColor = {
    contributing: colors.contributing[3],
    reading: colors.reading[3],
    content: colors.content[3]
};
var fakeSeries = [{ month: 'December 2015', metric: 60000 }, { month: 'January 2016', metric: 70000 }, { month: 'February 2016', metric: 80000 }, { month: 'March 2016', metric: 100340 }, { month: 'April 2016', metric: 80000 }, { month: 'May 2016', metric: 100340 }, { month: 'June 2016', metric: 80000 }, { month: 'July 2016', metric: 100340 }, { month: 'August 2016', metric: 80000 }, { month: 'September 2016', metric: 100340 }, { month: 'October 2016', metric: 80000 }, { month: 'November 2016', metric: 100340 }, { month: 'December 2016', metric: 80000 }, { month: 'January 2017', metric: 90000 }, { month: 'February 2017', metric: 100000 }, { month: 'March 2017', metric: 120340 }, { month: 'April 2017', metric: 100000 }, { month: 'May 2017', metric: 120340 }, { month: 'June 2017', metric: 100000 }, { month: 'July 2017', metric: 120340 }, { month: 'August 2017', metric: 100000 }, { month: 'September 2017', metric: 120340 }, { month: 'October 2017', metric: 100000 }, { month: 'November', metric: 120340 }];
var fakeDailySeries = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()({ length: 100 }, function (el, index) {
    return {
        day: new Date(2015, 10, index + 1),
        metric: 200 + Math.random() * 600 + index
    };
});
var detailDailySeries = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()({ length: 365 }, function (el, index) {
    return {
        day: new Date(2015, 10, index + 1),
        metric: 40000000 + Math.random() * 30000000 + index % 30 * 40000
    };
});
var detailSeries = [{ month: '2014-12-01', total: 80000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 70000, 'Very Active': 22000 }
    }
}, { month: '2015-01-01', total: 90000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 80000, 'Very Active': 22000 }
    }
}, { month: '2015-02-01', total: 100000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 90000, 'Very Active': 22000 }
    }
}, { month: '2015-03-01', total: 120340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 100000, 'Very Active': 38000 }
    }
}, { month: '2015-04-01', total: 100000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 90000, 'Very Active': 22000 }
    }
}, { month: '2015-05-01', total: 120340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 100000, 'Very Active': 38000 }
    }
}, { month: '2015-06-01', total: 100000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 90000, 'Very Active': 22000 }
    }
}, { month: '2015-07-01', total: 120340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 100000, 'Very Active': 38000 }
    }
}, { month: '2015-08-01', total: 100000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 90000, 'Very Active': 22000 }
    }
}, { month: '2015-09-01', total: 120340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 100000, 'Very Active': 38000 }
    }
}, { month: '2015-10-01', total: 100000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 90000, 'Very Active': 22000 }
    }
}, { month: '2015-11-01', total: 120340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 100000, 'Very Active': 38000 }
    }
}, { month: '2015-12-01', total: 130340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 110000, 'Very Active': 38000 }
    }
}, { month: '2015-12-01', total: 80000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 70000, 'Very Active': 22000 }
    }
}, { month: '2016-01-01', total: 90000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 80000, 'Very Active': 22000 }
    }
}, { month: '2016-02-01', total: 100000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 90000, 'Very Active': 22000 }
    }
}, { month: '2016-03-01', total: 120340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 100000, 'Very Active': 38000 }
    }
}, { month: '2016-04-01', total: 100000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 90000, 'Very Active': 22000 }
    }
}, { month: '2016-05-01', total: 120340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 100000, 'Very Active': 38000 }
    }
}, { month: '2016-06-01', total: 100000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 90000, 'Very Active': 22000 }
    }
}, { month: '2016-07-01', total: 120340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 100000, 'Very Active': 38000 }
    }
}, { month: '2016-08-01', total: 100000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 90000, 'Very Active': 22000 }
    }
}, { month: '2016-09-01', total: 120340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 100000, 'Very Active': 38000 }
    }
}, { month: '2016-10-01', total: 100000,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10000, 'Active': 90000, 'Very Active': 22000 }
    }
}, { month: '2016-11-01', total: 120340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 100000, 'Very Active': 38000 }
    }
}, { month: '2016-12-01', total: 130340,
    breakdowns: {
        'Activity Level': { 'Lightly Active': 10340, 'Active': 110000, 'Very Active': 38000 }
    }
}];

var questions = [{ f: true, a: 'contributing', m: 'Top Contributors', q: 'Who are the top contributors?' }, { a: 'contributing', m: 'New Editors', q: 'How many new editors are there?' }, { a: 'contributing', m: 'Newly registered users', q: 'How many new users are there?' }, { f: true, a: 'contributing', m: 'Active Editors', q: 'How many active editors are there?' }, { a: 'contributing', m: 'Total editors', q: 'How many editors are there?' }, { a: 'contributing', m: 'Editors by language', q: 'How many editors are there in the most populated countries?' }, { a: 'contributing', m: 'Total Edits', q: 'How many edits have been made?' }, { f: true, a: 'contributing', m: 'Non-bot edits', q: 'How many edits have been made by registered human users?' }, { a: 'contributing', m: 'Anonymous edits', q: 'How many edits have been made by anonymous users?' }, { a: 'contributing', m: 'Edits per article', q: 'How many edits does an article receive on average?' }, { a: 'contributing', m: 'Top edited articles', q: 'What are the most edited articles?' }, { a: 'contributing', m: 'Total Reverts', q: 'How many edits undo previous edits?' }, { f: true, a: 'reading', m: 'Total Pageviews', q: 'How many times are articles viewed?' }, { f: true, a: 'reading', m: 'Unique Devices', q: 'How many unique devices access content?' }, { f: true, a: 'reading', m: 'Most Viewed Articles', q: 'What are the most viewed articles?' }, { a: 'reading', m: 'Article Pageviews', q: 'How many times is an article viewed, on average?' }, { a: 'reading', m: 'Page Views per Edit?', q: 'How many times is a particular article version viewed?' }, { f: true, a: 'content', m: 'Total Articles', q: 'How many articles are there?' }, { f: true, a: 'content', m: 'Media Uploads', q: 'How much media is there (video, sound, images)?' }, { f: true, a: 'content', m: 'New articles', q: 'How many new articles are added?' }, { a: 'content', m: 'Top Article Creators', q: 'Who are the top article creators?' }, { a: 'content', m: 'Article size (bytes)', q: 'What is the size of all articles in bytes?' }, { a: 'content', m: 'Articles with most edits', q: 'What articles have the most edits?' }, { a: 'content', m: 'Articles with most contributors', q: 'What are the articles with the most contributors?' }, { a: 'content', m: 'Reference Links', q: 'Where do articles link to?' }];

var areasWithMetrics = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.transform(questions, function (result, q) {
    var area = result.find(function (a) {
        return a.name === q.a;
    });
    if (!area) {
        area = {
            name: q.a,
            order: { contributing: 1, reading: 2, content: 3 }[q.a],
            color: colors[q.a][1],
            metrics: []
        };
        result.unshift(area);
    }

    area.metrics.push({
        name: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.kebabCase(q.m),
        fullName: q.m
    });

    result.sort(function (a, b) {
        return a.order > b.order;
    });
    return result;
}, []);

var mainMetricsByArea = [{ state: { id: 'contributing', name: 'Contributing', metrics: ['non-bot-edits', 'active-editors', 'top-contributors'] } }, { state: { id: 'reading', name: 'Reading', metrics: ['total-pageviews', 'unique-devices', 'most-viewed-articles'] } }, { state: { id: 'content', name: 'Content', metrics: ['total-articles', 'new-articles', 'media-uploads'] } }];
var _metrics = {
    'non-bot-edits': {
        fullName: 'Non-bot edits',
        type: 'bars',
        area: 'contributing',
        series: fakeSeries,
        changeMoM: 3,
        changeYoY: 0.5,
        lastMonth: 'November',
        lastMonthValue: 120340,
        lastYear: 2016,
        lastYearValue: 1210000,
        detail: detailSeries
    },
    'active-editors': {
        fullName: 'Active Editors',
        type: 'bars',
        area: 'contributing',
        series: fakeSeries,
        changeMoM: 1,
        changeYoY: -0.5,
        lastMonth: 'November',
        lastMonthValue: 43203,
        lastYear: 2016,
        lastYearValue: 60102,
        breakdowns: [{ on: true, name: 'Activity Level', values: [{ name: 'Lightly Active', on: true }, { name: 'Active', on: true }, { name: 'Very Active', on: true }] }],
        detail: detailSeries.map(function (d) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(d, { total: d.total + 1 });
        })
    },
    'top-contributors': {
        fullName: 'Top Contributors',
        type: 'list',
        area: 'contributing',
        valueName: 'Total Edits for November',
        valueFilter: 'thousands',
        showNumbers: true,
        sortedList: [{ name: 'Username 1', value: 124503 }, { name: 'Username 2', value: 123954 }, { name: 'Username 3', value: 122031 }, { name: 'Username 4', value: 110891 }]
    },
    'total-pageviews': {
        fullName: 'Total Page Views',
        type: 'bars',
        area: 'reading',
        series: fakeSeries,
        changeMoM: 3,
        changeYoY: -0.5,
        lastMonth: 'November',
        lastMonthValue: 7741345234,
        lastYear: 2016,
        lastYearValue: 25341345234,
        detail: detailSeries
    },
    'unique-devices': {
        fullName: 'Unique Devices',
        type: 'lines',
        area: 'reading',
        series: fakeDailySeries,
        changeMoM: 3,
        changeYoY: -0.5,
        lastMonth: 'November',
        lastMonthValue: 4921109000,
        lastYear: 2016,
        lastYearValue: 20101345234,
        detail: detailDailySeries
    },
    'most-viewed-articles': {
        fullName: 'Most Viewed Articles',
        type: 'list',
        area: 'reading',
        valueName: 'Total Views November',
        valueFilter: 'kmb',
        showNumbers: false,
        sortedList: [{ name: 'Long article name here one', value: 2103000 }, { name: 'Long article name here two', value: 2000900 }, { name: 'Long article name here three', value: 1910000 }, { name: 'Long article name here four', value: 1800001 }]
    },
    'total-articles': {
        fullName: 'Total Articles',
        type: 'bars',
        area: 'content',
        series: fakeSeries,
        changeMoM: 3,
        changeYoY: -0.5,
        lastMonth: 'November',
        lastMonthValue: 10741345234,
        lastYear: 2016,
        lastYearValue: 25341345234,
        detail: detailSeries
    },
    'new-articles': {
        fullName: 'New Articles',
        type: 'bars',
        area: 'content',
        series: fakeSeries,
        changeMoM: 3,
        changeYoY: -0.5,
        lastMonth: 'November',
        lastMonthValue: 1435321,
        lastYear: 2016,
        lastYearValue: 12445234,
        detail: detailSeries
    },
    'media-uploads': {
        fullName: 'Media Uploads',
        type: 'bars',
        area: 'content',
        series: fakeSeries,
        changeMoM: 3,
        changeYoY: -0.5,
        lastMonth: 'November',
        lastMonthValue: 1940713,
        lastYear: 2016,
        lastYearValue: 2145234,
        detail: detailSeries
    }
};

/* harmony default export */ __webpack_exports__["a"] = {
    metricData: function metricData(metricName, area) {
        var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var result = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.assign(_metrics[metricName], { lightColor: lightColor[area] }, { darkColor: darkColor[area] });
            setTimeout(function () {
                return resolve(result);
            }, Math.random() * 500);
        });

        return promise;
    },
    metrics: function metrics() {
        var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            resolve(_metrics);
        });

        return promise;
    },
    areas: function areas() {
        var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            resolve([{ path: '/', name: 'Dashboard' }, { path: '/contributing', name: 'Contributing' }, { path: '/reading', name: 'Reading' }, { path: '/content', name: 'Content' }]);
        });

        return promise;
    },
    areaData: function areaData() {
        var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            resolve(mainMetricsByArea);
        });

        return promise;
    },


    colors: colors,
    stableColorIndexes: stableColorIndexes,
    questions: questions,
    areasWithMetrics: areasWithMetrics
};

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Detail__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Detail__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{ path: '/:area/:metric?', component: __WEBPACK_IMPORTED_MODULE_3__components_Detail___default.a,
    name: 'Detail'
  }, { path: '/', component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard___default.a,
    name: 'Dashboard'
  }]
});

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(358)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(397),
  /* scopeId */
  "data-v-af2932e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(360)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(399),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(354)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(392),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopNav__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_TopNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopicExplorer__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopicExplorer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_TopicExplorer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteLanguage__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SiteLanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SiteLanguage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BottomFooter__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BottomFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_BottomFooter__);







/* harmony default export */ __webpack_exports__["default"] = {
    name: 'app',
    data: function data() {
        return {
            warning: true,
            wiki: 'Wikipedia (All languages)'
        };
    },
    mounted: function mounted() {
        var self = this;
        setTimeout(function () {
            self.warning = false;
        }, 7000);
    },

    components: {
        TopNav: __WEBPACK_IMPORTED_MODULE_0__components_TopNav___default.a,
        TopicExplorer: __WEBPACK_IMPORTED_MODULE_1__components_TopicExplorer___default.a,
        SiteLanguage: __WEBPACK_IMPORTED_MODULE_2__components_SiteLanguage___default.a,
        BottomFooter: __WEBPACK_IMPORTED_MODULE_3__components_BottomFooter___default.a
    },
    methods: {
        wikiSelected: function wikiSelected(wiki) {
            this.wiki = wiki;
        }
    }
};

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    name: 'arrow-icon',
    props: ['value']
};

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_scale__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_axis__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_format__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_time__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apis_Configuration__ = __webpack_require__(8);











/* harmony default export */ __webpack_exports__["default"] = {
    name: 'bar-chart',
    props: ['data', 'breakdown'],

    mounted: function mounted() {
        this.drawChart();
    },


    watch: {
        data: {
            handler: function handler() {
                this.drawChart();
            },
            deep: true
        },

        breakdown: function breakdown() {
            this.drawChart();
        }
    },

    methods: {
        drawChart: function drawChart() {
            var self = this;

            var root = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["a" /* select */](this.$el),
                margin = { top: 6, right: 0, bottom: 20, left: 40 },
                padding = 4;

            root.selectAll('*').remove();

            var svg = root.append('svg'),
                g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var data = self.data.detail ? self.data : { detail: [] };

            function resize() {
                var n = root.node(),
                    width = n.offsetWidth - margin.left - margin.right,
                    height = n.offsetHeight - margin.top - margin.bottom - padding,
                    x = __WEBPACK_IMPORTED_MODULE_1_d3_scale__["a" /* scaleTime */]().rangeRound([0, width]),
                    y = __WEBPACK_IMPORTED_MODULE_1_d3_scale__["b" /* scaleLinear */]().rangeRound([height, 0]),
                    xW = __WEBPACK_IMPORTED_MODULE_1_d3_scale__["c" /* scaleBand */]().align(0).padding(0.92),
                    dates = data.detail.map(function (d) {
                    return new Date(Date.parse(d.month));
                });

                x.domain(__WEBPACK_IMPORTED_MODULE_2_d3_array__["a" /* extent */](dates));
                y.domain([0, __WEBPACK_IMPORTED_MODULE_2_d3_array__["b" /* max */](data.detail.map(function (d) {
                    return d.total;
                }))]);

                xW.range(x.range()).domain(x.domain());

                svg.attr('width', n.offsetWidth).attr('height', n.offsetHeight);
                g.attr('width', width).attr('height', height);

                if (self.breakdown) {
                    g.append('g').selectAll('.bar').data(data.detail).enter().selectAll('.minibar').data(function (d) {
                        var breakdown = self.data.breakdowns[0];
                        var breakdowns = breakdown.values.filter(function (x) {
                            return x.on;
                        });

                        var newData = breakdowns.map(function (b, i) {
                            return {
                                month: d.month,
                                key: b.name,
                                value: d.breakdowns[breakdown.name][b.name],
                                color: __WEBPACK_IMPORTED_MODULE_6__apis_Configuration__["a" /* default */].colors[self.data.area][[__WEBPACK_IMPORTED_MODULE_6__apis_Configuration__["a" /* default */].stableColorIndexes[b.name]]],
                                width: xW.bandwidth() / breakdowns.length,
                                index: i
                            };
                        });

                        return newData;
                    }).enter().append('rect').attr('x', function (d) {
                        return x(Date.parse(d.month)) + d.index * d.width / xW.padding();
                    }).attr('y', function (d) {
                        return y(d.value);
                    }).attr('width', function (d) {
                        return d.width;
                    }).attr('height', function (d) {
                        return height - y(d.value);
                    }).attr('fill', function (d) {
                        return d.color;
                    });
                } else {
                    g.append('g').selectAll('.bar').data(data.detail).enter().append('rect').attr('x', function (d) {
                        return x(Date.parse(d.month));
                    }).attr('y', function (d) {
                        return y(d.total);
                    }).attr('width', xW.bandwidth()).attr('height', function (d) {
                        return height - y(d.total);
                    }).attr('fill', function (d) {
                        return self.data.darkColor;
                    });
                }

                var xAxis = __WEBPACK_IMPORTED_MODULE_3_d3_axis__["a" /* axisBottom */](x).ticks(__WEBPACK_IMPORTED_MODULE_5_d3_time__["o" /* timeMonth */].every(3)),
                    yAxis = __WEBPACK_IMPORTED_MODULE_3_d3_axis__["b" /* axisLeft */](y).ticks(7).tickFormat(__WEBPACK_IMPORTED_MODULE_4_d3_format__["f" /* format */]('0.00s'));

                g.append('g').call(yAxis).style('font-size', '13px').style('font-family', 'Lato, "Open Sans"');
                g.append('g').attr('transform', 'translate(0,' + height + ')').call(xAxis).style('font-size', '13px').style('font-family', 'Lato, "Open Sans"');
            }
            resize();
        }
    }
};

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'bottom-footer'
};

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DashboardArea__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DashboardArea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DashboardArea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WikiSelector__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WikiSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__WikiSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Configuration__ = __webpack_require__(8);






/* harmony default export */ __webpack_exports__["default"] = {
    name: 'dashboard',
    props: ['wiki'],
    components: {
        DashboardArea: __WEBPACK_IMPORTED_MODULE_0__DashboardArea___default.a,
        WikiSelector: __WEBPACK_IMPORTED_MODULE_1__WikiSelector___default.a
    },

    data: function data() {
        return {
            areas: []
        };
    },
    mounted: function mounted() {
        $('body').scrollTop(0);
        this.load();
    },


    methods: {
        wikiSelected: function wikiSelected(wiki) {
            this.$emit('wiki', wiki);
        },
        load: function load() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_2__apis_Configuration__["a" /* default */].areaData().then(function (result) {
                self.areas = result;
            });
        }
    }
};

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetricWidget__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetricWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MetricWidget__);




/* harmony default export */ __webpack_exports__["default"] = {
    name: 'dashboard-area',
    props: ['area'],

    components: {
        MetricWidget: __WEBPACK_IMPORTED_MODULE_0__MetricWidget___default.a
    }
};

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WikiSelector__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WikiSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__WikiSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleLegend__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleLegend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SimpleLegend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArrowIcon__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArrowIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ArrowIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TimeRangeSelector__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TimeRangeSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TimeRangeSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BarChart__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LineChart__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LineChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__LineChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MapChart__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MapChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__MapChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TableChart__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TableChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__TableChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EmptyChart__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EmptyChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__EmptyChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__apis_Configuration__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_index__ = __webpack_require__(45);


















/* harmony default export */ __webpack_exports__["default"] = {
    name: 'detail',
    props: ['wiki'],
    components: {
        WikiSelector: __WEBPACK_IMPORTED_MODULE_2__WikiSelector___default.a,
        SimpleLegend: __WEBPACK_IMPORTED_MODULE_3__SimpleLegend___default.a,
        ArrowIcon: __WEBPACK_IMPORTED_MODULE_4__ArrowIcon___default.a,
        TimeRangeSelector: __WEBPACK_IMPORTED_MODULE_5__TimeRangeSelector___default.a,

        BarChart: __WEBPACK_IMPORTED_MODULE_6__BarChart___default.a,
        LineChart: __WEBPACK_IMPORTED_MODULE_7__LineChart___default.a,
        MapChart: __WEBPACK_IMPORTED_MODULE_8__MapChart___default.a,
        TableChart: __WEBPACK_IMPORTED_MODULE_9__TableChart___default.a,
        EmptyChart: __WEBPACK_IMPORTED_MODULE_10__EmptyChart___default.a
    },
    data: function data() {
        return {
            fullscreen: false,
            areasWithMetrics: __WEBPACK_IMPORTED_MODULE_11__apis_Configuration__["a" /* default */].areasWithMetrics,
            highlightMetric: {},

            chartTypes: [],
            chartType: null,
            chartIcon: 'empty',
            availableChartTypes: [{ chart: 'bar', icon: 'bar' }, { chart: 'line', icon: 'line' }, { chart: 'map', icon: 'globe' }, { chart: 'table', icon: 'table' }],

            defaultMetrics: {
                contributing: 'active-editors',
                reading: 'total-pageviews',
                content: 'total-articles'
            },

            otherMetrics: [],

            metricData: {},

            breakdowns: []
        };
    },


    computed: {
        chartComponent: function chartComponent() {
            return (this.chartType || 'empty') + '-chart';
        },
        area: function area() {
            return this.$route.params ? this.$route.params.area : 'loading ...';
        },
        metric: function metric() {
            return this.$route.params.metric ? this.$route.params.metric : this.defaultMetrics[this.area];
        },

        breakdown: function breakdown() {
            return (this.breakdowns || []).find(function (m) {
                return m.on;
            });
        },

        total: function total() {
            if (!this.metricData.detail) {
                return 0;
            }

            return this.metricData.detail.reduce(function (r, m) {
                return r + m.total;
            }, 0);
        }
    },

    watch: {
        'metric': function metric() {
            this.loadData();
            this.filterChartTypes();
        },
        'metricData.type': function metricDataType() {
            this.filterChartTypes();
        }
    },

    mounted: function mounted() {
        $('body').scrollTop(0);
        this.loadData();
        $('.ui.metrics.modal').modal();
    },


    methods: {
        filterChartTypes: function filterChartTypes() {
            var self = this;

            self.chartTypes = self.availableChartTypes.filter(function (c) {
                if (!self.metricData) {
                    return false;
                }
                if (self.metricData.type === 'bars') {
                    return c.chart !== 'line';
                }
                if (self.metricData.type === 'lines') {
                    return c.chart === 'line';
                }
                return c.chart === 'table';
            });

            self.chartType = self.chartTypes[0].chart;
            self.chartIcon = self.chartTypes[0].icon;
        },
        wikiSelected: function wikiSelected(wiki) {
            this.$emit('wiki', wiki);
        },
        loadData: function loadData() {
            var self = this;

            this.highlightMetric = { name: this.metric, area: this.area };

            __WEBPACK_IMPORTED_MODULE_11__apis_Configuration__["a" /* default */].metricData(this.metric, this.area).then(function (result) {
                self.metricData = result;
                self.breakdowns = result.breakdowns;
            });

            __WEBPACK_IMPORTED_MODULE_11__apis_Configuration__["a" /* default */].metrics(this.area).then(function (result) {
                var relevantMetrics = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result).filter(function (m) {
                    return result[m].area === self.area;
                });

                self.otherMetrics = relevantMetrics.map(function (m) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(result[m], { name: m });
                });
            });
        },
        changeChart: function changeChart(t) {
            this.chartType = t.chart;
            this.chartIcon = t.icon;
        },
        toggleFullscreen: function toggleFullscreen() {
            this.fullscreen = !this.fullscreen;

            var t = this.metricData,
                self = this;
            this.metricData = {};
            setTimeout(function () {
                self.metricData = t;
            }, 0);
        },
        addAnotherWiki: function addAnotherWiki() {
            $('.add.wiki.design').toggle('highlight');
        },
        viewMoreMetrics: function viewMoreMetrics() {
            $('.ui.metrics.modal').modal('show');
        },
        changeHighlight: function changeHighlight(name, area) {
            this.highlightMetric = { name: name, area: area };
        },
        goHighlight: function goHighlight(area) {
            var h = this.highlightMetric;
            __WEBPACK_IMPORTED_MODULE_12__router_index__["a" /* default */].push('/' + h.area + '/' + h.name);
            $('.ui.metrics.modal').modal('hide');
        }
    }
};

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    name: 'empty-chart'
};

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_scale__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_axis__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_format__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_time__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_shape__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apis_Configuration__ = __webpack_require__(8);












/* harmony default export */ __webpack_exports__["default"] = {
    name: 'line-chart',
    props: ['data', 'breakdown'],

    mounted: function mounted() {
        this.drawChart();
    },


    watch: {
        data: {
            handler: function handler() {
                this.drawChart();
            },
            deep: true
        },

        breakdown: function breakdown() {
            this.drawChart();
        }
    },

    methods: {
        drawChart: function drawChart() {
            var self = this;

            var root = __WEBPACK_IMPORTED_MODULE_0_d3_selection__["a" /* select */](this.$el),
                margin = { top: 6, right: 0, bottom: 20, left: 40 },
                padding = 4;

            root.selectAll('*').remove();

            var svg = root.append('svg'),
                g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var data = self.data.detail ? self.data : { detail: [] };

            function resize() {
                var n = root.node(),
                    width = n.offsetWidth - margin.left - margin.right,
                    height = n.offsetHeight - margin.top - margin.bottom - padding,
                    x = __WEBPACK_IMPORTED_MODULE_1_d3_scale__["a" /* scaleTime */]().rangeRound([0, width]),
                    y = __WEBPACK_IMPORTED_MODULE_1_d3_scale__["b" /* scaleLinear */]().rangeRound([height, 0]),
                    dates = data.detail.map(function (d) {
                    return d.day;
                });

                x.domain(__WEBPACK_IMPORTED_MODULE_2_d3_array__["a" /* extent */](dates));
                y.domain([0, __WEBPACK_IMPORTED_MODULE_2_d3_array__["b" /* max */](data.detail.map(function (d) {
                    return d.metric;
                }))]);

                svg.attr('width', n.offsetWidth).attr('height', n.offsetHeight);
                g.attr('width', width).attr('height', height);

                var line = __WEBPACK_IMPORTED_MODULE_6_d3_shape__["a" /* line */]().x(function (d) {
                    return x(d.day);
                }).y(function (d) {
                    return y(d.metric);
                }).curve(__WEBPACK_IMPORTED_MODULE_6_d3_shape__["b" /* curveBundle */].beta(0.5));

                if (self.breakdown) {
                    alert('breakdown not implemented yet for line charts');
                } else {
                    g.append('path').datum(data.detail).attr('d', line).style('stroke', self.data.darkColor).style('stroke-width', '2px').style('fill', 'none');
                }

                var xAxis = __WEBPACK_IMPORTED_MODULE_3_d3_axis__["a" /* axisBottom */](x).ticks(__WEBPACK_IMPORTED_MODULE_5_d3_time__["o" /* timeMonth */].every(3)),
                    yAxis = __WEBPACK_IMPORTED_MODULE_3_d3_axis__["b" /* axisLeft */](y).ticks(7).tickFormat(__WEBPACK_IMPORTED_MODULE_4_d3_format__["f" /* format */]('0.00s'));

                g.append('g').call(yAxis).style('font-size', '13px').style('font-family', 'Lato, "Open Sans"');
                g.append('g').attr('transform', 'translate(0,' + height + ')').call(xAxis).style('font-size', '13px').style('font-family', 'Lato, "Open Sans"');
            }
            resize();
        }
    }
};

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    name: 'map-chart',
    props: ['data']
};

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowIcon__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ArrowIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_array__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = {
    name: 'metric-bar-widget',
    props: ['data'],

    components: {
        ArrowIcon: __WEBPACK_IMPORTED_MODULE_0__ArrowIcon___default.a
    },

    mounted: function mounted() {
        this.drawChart();
    },


    methods: {
        drawChart: function drawChart() {
            var self = this;

            var root = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* select */](this.$el).select('.bar-chart'),
                margin = { top: 16, right: 0, bottom: 8, left: 0 },
                padding = 4;

            var svg = root.append('svg'),
                g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var data = self.data.series ? self.data : { series: [] };

            function resize() {
                var n = root.node(),
                    width = n.offsetWidth - margin.left - margin.right,
                    height = n.offsetHeight - margin.top - margin.bottom - padding,
                    x = __WEBPACK_IMPORTED_MODULE_2_d3_scale__["c" /* scaleBand */]().rangeRound([0, width]).padding(0.3),
                    y = __WEBPACK_IMPORTED_MODULE_2_d3_scale__["b" /* scaleLinear */]().rangeRound([height, 0]);

                x.domain(data.series.map(function (d) {
                    return d.month;
                }));
                y.domain([0, __WEBPACK_IMPORTED_MODULE_3_d3_array__["b" /* max */](data.series.map(function (d) {
                    return d.metric;
                }))]);

                svg.attr('width', n.offsetWidth).attr('height', n.offsetHeight);
                g.attr('width', width).attr('height', height);

                g.append('g').selectAll('.bar').data(data.series).enter().append('rect').attr('x', function (d) {
                    return x(d.month);
                }).attr('y', function (d) {
                    return y(d.metric);
                }).attr('width', x.bandwidth()).attr('height', function (d) {
                    return height - y(d.metric);
                }).attr('fill', function (d) {
                    return d.month === self.data.lastMonth ? self.data.darkColor : self.data.lightColor;
                });

                g.append('g').classed('month-ticks', true).attr('transform', 'translate(' + (x.bandwidth() / 2 - 3) + ',' + 12 + ')').selectAll('.month').data(data.series).enter().append('text').attr('x', function (d) {
                    return x(d.month);
                }).attr('y', height).text(function (d) {
                    return d.month.substring(0, 1);
                }).style('fill', '#898989').style('font-size', '9px').style('font-family', 'Lato');
            }
            resize();
        }
    }
};

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowIcon__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ArrowIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_selection__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_array__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_shape__ = __webpack_require__(126);








/* harmony default export */ __webpack_exports__["default"] = {
    name: 'metric-line-widget',
    props: ['data'],

    components: {
        ArrowIcon: __WEBPACK_IMPORTED_MODULE_0__ArrowIcon___default.a
    },

    mounted: function mounted() {
        this.drawChart();
    },


    methods: {
        drawChart: function drawChart() {
            var self = this;

            var root = __WEBPACK_IMPORTED_MODULE_1_d3_selection__["a" /* select */](this.$el).select('.line-chart'),
                margin = { top: 0, right: 0, bottom: 0, left: 0 },
                padding = 4;

            var svg = root.append('svg'),
                g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            var data = self.data.series ? self.data : { series: [] };

            function resize() {
                var n = root.node(),
                    width = n.offsetWidth - margin.left - margin.right,
                    height = n.offsetHeight - margin.top - margin.bottom - padding,
                    x = __WEBPACK_IMPORTED_MODULE_2_d3_scale__["a" /* scaleTime */]().rangeRound([0, width]),
                    y = __WEBPACK_IMPORTED_MODULE_2_d3_scale__["b" /* scaleLinear */]().rangeRound([height, 0]);

                x.domain(__WEBPACK_IMPORTED_MODULE_3_d3_array__["a" /* extent */](data.series.map(function (d) {
                    return d.day;
                })));
                y.domain([0, __WEBPACK_IMPORTED_MODULE_3_d3_array__["b" /* max */](data.series.map(function (d) {
                    return d.metric;
                }))]);

                var line = __WEBPACK_IMPORTED_MODULE_4_d3_shape__["a" /* line */]().x(function (d) {
                    return x(d.day);
                }).y(function (d) {
                    return y(d.metric);
                }).curve(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["b" /* curveBundle */].beta(0.3));

                svg.attr('width', n.offsetWidth).attr('height', n.offsetHeight);
                g.attr('width', width).attr('height', height);

                g.append('path').datum(data.series).attr('d', line).style('stroke', self.data.darkColor).style('stroke-width', '2px').style('fill', 'none');
            }
            resize();
        }
    }
};

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["default"] = {
    name: 'metric-list-widget',
    props: ['data'],

    computed: {
        formattedList: function formattedList() {
            var _this = this;

            if (!this.data.valueFilter) {
                return this.data.sortedList;
            }

            return this.data.sortedList.map(function (l) {
                return {
                    value: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].options.filters[_this.data.valueFilter](l.value),
                    name: l.name
                };
            });
        }
    },

    methods: {
        format: function format(value) {}
    }
};

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetricBarWidget__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MetricBarWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MetricBarWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetricLineWidget__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MetricLineWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__MetricLineWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricListWidget__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MetricListWidget___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MetricListWidget__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_Configuration__ = __webpack_require__(8);







/* harmony default export */ __webpack_exports__["default"] = {
    name: 'metric-widget',
    props: ['metric', 'area'],
    data: function data() {
        return {
            loading: false,
            metricData: {}
        };
    },


    components: {
        MetricBarWidget: __WEBPACK_IMPORTED_MODULE_0__MetricBarWidget___default.a,
        MetricLineWidget: __WEBPACK_IMPORTED_MODULE_1__MetricLineWidget___default.a,
        MetricListWidget: __WEBPACK_IMPORTED_MODULE_2__MetricListWidget___default.a
    },

    watch: {
        '$route.params': 'load'
    },

    created: function created() {
        this.load();
    },


    methods: {
        load: function load() {
            var self = this;
            self.loading = true;

            __WEBPACK_IMPORTED_MODULE_3__apis_Configuration__["a" /* default */].metricData(self.metric.name, self.area).then(function (result) {
                self.metricData = result;
                self.loading = false;
            });
        }
    }
};

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Configuration__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = {
    name: 'simple-legend',
    props: ['data'],

    data: function data() {
        return {
            ci: __WEBPACK_IMPORTED_MODULE_0__apis_Configuration__["a" /* default */].stableColorIndexes
        };
    },


    computed: {
        colors: function colors() {
            return __WEBPACK_IMPORTED_MODULE_0__apis_Configuration__["a" /* default */].colors[this.data.area];
        }
    }
};

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    name: 'site-language'
};

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    name: 'map-chart',
    props: ['data', 'breakdown'],

    mounted: function mounted() {
        this.setColors();
    },
    updated: function updated() {
        this.setColors();
    },


    methods: {
        setColors: function setColors() {
            var headerCells = this.$el.querySelectorAll('th');
            var i = null;

            for (var _i = 0; _i < headerCells.length; _i++) {
                headerCells[_i].style = 'background-color: ' + this.data.darkColor + ';';
            }
        }
    }
};

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    name: 'time-range-selector'
};

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Configuration__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = {
    name: 'top-nav',
    data: function data() {
        return {
            areas: []
        };
    },
    mounted: function mounted() {
        this.load();
    },


    methods: {
        load: function load() {
            var self = this;
            __WEBPACK_IMPORTED_MODULE_0__apis_Configuration__["a" /* default */].areas().then(function (result) {
                self.areas = result;
            });
        }
    }
};

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Configuration__ = __webpack_require__(8);






/* harmony default export */ __webpack_exports__["default"] = {
    name: 'topic-explorer',

    data: function data() {
        return {
            minimized: true,

            selectedQuestion: null
        };
    },


    computed: {
        contributingQuestions: function contributingQuestions() {
            return __WEBPACK_IMPORTED_MODULE_2__apis_Configuration__["a" /* default */].questions.filter(function (m) {
                return m.f && m.a === 'contributing';
            });
        },
        readingQuestions: function readingQuestions() {
            return __WEBPACK_IMPORTED_MODULE_2__apis_Configuration__["a" /* default */].questions.filter(function (m) {
                return m.f && m.a === 'reading';
            });
        },
        contentQuestions: function contentQuestions() {
            return __WEBPACK_IMPORTED_MODULE_2__apis_Configuration__["a" /* default */].questions.filter(function (m) {
                return m.f && m.a === 'content';
            });
        },
        moreQuestions: function moreQuestions() {
            return __WEBPACK_IMPORTED_MODULE_2__apis_Configuration__["a" /* default */].questions.filter(function (m) {
                return !m.f;
            });
        }
    },

    methods: {
        selectQuestion: function selectQuestion(q) {
            this.selectedQuestion = q;
        },
        go: function go() {
            var s = this.selectedQuestion;
            __WEBPACK_IMPORTED_MODULE_0__router_index__["a" /* default */].push('/' + s.a + '/' + __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.kebabCase(s.m));
        }
    }
};

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
    name: 'wiki-selector',
    props: ['wiki', 'single'],

    mounted: function mounted() {
        var self = this;

        $('.ui.search').search({
            onSelect: function onSelect(wiki) {
                self.$emit('wiki', wiki.title);
                $('.ui.search', self.$el).removeClass('focus');
            },

            source: [{ title: 'Commons' }, { title: 'Wikibooks (All languages)' }, { title: 'Wikidata' }, { title: 'Wikinews (All languages)' }, { title: 'Wikipedia (All languages)' }, { title: 'Wikiquote (All languages)' }, { title: 'Wikisource (All languages)' }, { title: 'Wikispecies (All languages)' }, { title: 'Wikiversity (All languages)' }, { title: 'Wikivoyage (All languages)' }, { title: 'Wiktionary (All languages)' }],
            searchFields: ['title'],
            searchFullText: true
        });
    }
};

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4KCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIgogICBpZD0iV2lraW1lZGlhIGxvZ28iCiAgIHZpZXdCb3g9Ii01OTkgLTU5OSAxMTk4IDExOTgiIHdpZHRoPSIxMDI0IiBoZWlnaHQ9IjEwMjQiPgo8ZGVmcz4KICA8Y2xpcFBhdGggaWQ9Im1hc2siPgogICAgPHBhdGggZD0iTSA0Ny41LC04Ny41IHYgNDI1IGggLTk1IHYgLTQyNSBsIC01NTIsLTU1MiB2IDEyNTAgaCAxMTk5IHYgLTEyNTAgeiIgLz4KICA8L2NsaXBQYXRoPgo8L2RlZnM+CjxnIGNsaXAtcGF0aD0idXJsKCNtYXNrKSI+CiAgPGNpcmNsZSBpZD0iZ3JlZW4gcGFydHMiIGZpbGw9IiMzOTYiIHI9IjMzNi41Ii8+CiAgPGNpcmNsZSBpZD0iYmx1ZSBhcmMiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzA2OSIgcj0iNDgwLjI1IiBzdHJva2Utd2lkdGg9IjEzNS41IiAvPgo8L2c+CjxjaXJjbGUgZmlsbD0iIzkwMCIgY3k9Ii0zNzkuNSIgcj0iMTg0LjUiIGlkPSJyZWQgY2lyY2xlIi8+Cjwvc3ZnPgo="

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(352)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(390),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(349)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(386),
  /* scopeId */
  "data-v-3278ed8b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(357)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(396),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(361)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(401),
  /* scopeId */
  "data-v-f2502aa8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(344)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(381),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(395),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(353)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(391),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(389),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(350)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(387),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(351)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(388),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(356)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(394),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(346)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(383),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(345)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(382),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(347)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  "data-v-1e8e2924",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(359)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(398),
  /* scopeId */
  "data-v-c2da9656",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(400),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(355)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(393),
  /* scopeId */
  "data-v-7b9d7b33",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(348)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(385),
  /* scopeId */
  "data-v-2c9ba179",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "detail container",
    class: {
      area: _vm.area, fullscreen: _vm.fullscreen
    }
  }, [(!_vm.fullscreen) ? _c('section', {
    staticClass: "left panel"
  }, [_c('div', {
    staticClass: "wikis"
  }, [_c('h3', {
    staticClass: "header"
  }, [_vm._v("Wiki")]), _vm._v(" "), _c('wiki-selector', {
    attrs: {
      "wiki": _vm.wiki,
      "single": "false"
    },
    on: {
      "wiki": _vm.wikiSelected
    }
  }), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addAnotherWiki($event)
      }
    }
  }, [_vm._v("Add another Wiki")])]), _vm._m(0), _vm._v(" "), _c('p')], 1), _vm._v(" "), _c('div', {
    staticClass: "ui clearing divider"
  }), _vm._v(" "), _c('h3', {
    staticClass: "header"
  }, [_vm._v("Metrics")]), _vm._v(" "), _vm._l((_vm.otherMetrics), function(o) {
    return _c('router-link', {
      key: o.name,
      staticClass: "ui line label",
      class: {
        active: o.name === _vm.metric
      },
      attrs: {
        "to": '/' + _vm.area + '/' + o.name
      }
    }, [_vm._v("\n            " + _vm._s(o.fullName) + "\n        ")])
  }), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewMoreMetrics($event)
      }
    }
  }, [_vm._v("View more metrics")])]), _vm._v(" "), (_vm.breakdowns) ? _c('div', [_c('div', {
    staticClass: "ui clearing divider"
  }), _vm._v(" "), _c('h3', {
    staticClass: "header"
  }, [_vm._v("Filters and Breakdowns")]), _vm._v(" "), _vm._l((_vm.breakdowns), function(b) {
    return _c('div', [_vm._v("\n                Show:\n                "), _vm._l((b.values), function(bv) {
      return _c('label', {
        staticClass: "xui checkbox"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (bv.on),
          expression: "bv.on"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(bv.on) ? _vm._i(bv.on, null) > -1 : (bv.on)
        },
        on: {
          "__c": function($event) {
            var $$a = bv.on,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$c) {
                $$i < 0 && (bv.on = $$a.concat($$v))
              } else {
                $$i > -1 && (bv.on = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              bv.on = $$c
            }
          }
        }
      }), _vm._v("\n                    " + _vm._s(bv.name) + "\n                ")])
    }), _vm._v(" "), _c('div', {
      staticClass: "ui toggle checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (b.on),
        expression: "b.on"
      }],
      attrs: {
        "type": "checkbox",
        "id": "breakdown"
      },
      domProps: {
        "checked": Array.isArray(b.on) ? _vm._i(b.on, null) > -1 : (b.on)
      },
      on: {
        "__c": function($event) {
          var $$a = b.on,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (b.on = $$a.concat($$v))
            } else {
              $$i > -1 && (b.on = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            b.on = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": "breakdown"
      }
    }, [_vm._v("\n                        Breakdown\n                        "), (!b.on) ? _c('span', [_vm._v("Off")]) : _vm._e(), _vm._v(" "), (b.on) ? _c('span', [_vm._v("On")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "help circle icon",
      attrs: {
        "title": "Breakdowns help you see more detail by breaking down the total values into parts."
      }
    })])])], 2)
  })], 2) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "graph panel"
  }, [_c('div', {
    staticClass: "ui clearing basic segment"
  }, [_c('h2', {
    staticClass: "ui left floated header"
  }, [_vm._v("\n                " + _vm._s(_vm.metricData.fullName || 'No data yet... ') + "\n                "), _c('span', {
    staticClass: "subdued"
  }, [_vm._v(_vm._s(_vm.wiki.replace(' (All languages)', '')))])]), _vm._v(" "), _c('div', {
    staticClass: "ui right floated basic fudge segment"
  }, [(_vm.chartType === 'bar') ? _c('simple-legend', {
    staticClass: "simple legend",
    attrs: {
      "data": _vm.metricData
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui right floated icon buttons"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui simple dropdown right labeled icon button",
    attrs: {
      "title": "Change Chart"
    }
  }, [_c('i', {
    staticClass: "ui dropdown icon"
  }), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "chart icon",
    class: _vm.chartIcon
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, _vm._l((_vm.chartTypes), function(t) {
    return _c('div', {
      key: t.chart,
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.changeChart(t)
        }
      }
    }, [_c('i', {
      staticClass: "chart icon",
      class: t.icon
    }), _vm._v("\n                                 " + _vm._s(t.chart) + "\n                             ")])
  }))])])], 1)]), _vm._v(" "), _c(_vm.chartComponent, {
    tag: "component",
    attrs: {
      "data": _vm.metricData,
      "breakdown": _vm.breakdown
    }
  }), _vm._v(" "), (_vm.metricData.type !== 'list') ? _c('div', {
    staticClass: "ui center aligned basic segment"
  }, [_c('time-range-selector'), _vm._v(" "), _c('h5', [_vm._v("\n                Total: " + _vm._s(_vm._f("kmb")(_vm.total)) + " " + _vm._s(_vm.metricData.fullName) + " "), _c('arrow-icon', {
    attrs: {
      "value": _vm.metricData.changeYoY
    }
  }), _vm._v(" " + _vm._s(_vm.metricData.changeYoY) + " "), _c('i', [_vm._v("this year")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned subdued basic segment"
  }, [_c('p', [_vm._v("* Definition of " + _vm._s(_vm.metric) + " goes here, pulled from config or maybe dynamically from the wiki page.")]), _vm._v(" "), _c('p', [_vm._v("More descriptor text will go here assuming that it takes a few sentences to explain a term for a metric.")])]), _vm._v(" "), _c('div', {
    staticClass: "ui right floated icon button",
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('i', {
    staticClass: "ui icon",
    class: {
      expand: !_vm.fullscreen, compress: _vm.fullscreen
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui metrics modal"
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui three column grid"
  }, _vm._l((_vm.areasWithMetrics), function(a) {
    return _c('div', {
      staticClass: "column"
    }, [_c('h4', {
      class: a.name,
      style: ({
        borderBottom: '2px solid ' + a.color
      })
    }, [_vm._v(_vm._s(a.name))]), _vm._v(" "), _vm._l((a.metrics), function(m) {
      return _c('div', {
        key: m.name,
        staticClass: "ui line label",
        class: {
          active: m.name === _vm.highlightMetric.name
        },
        on: {
          "click": function($event) {
            _vm.changeHighlight(m.name, a.name)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(m.fullName) + "\n                ")])
    })], 2)
  })), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui blue button",
    on: {
      "click": _vm.goHighlight
    }
  }, [_vm._v("Go")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add wiki design"
  }, [_vm._v("\n                    \"Add another Wiki\" is not implemented in the prototype.  But you can see how it would work in "), _c('a', {
    attrs: {
      "target": "_new",
      "href": "https://www.dropbox.com/sh/lfrn4lcjyqhou7o/AAAmzec_63b1UwaZCGFDw1gea?dl=0&preview=Detail+Page+Two+Wiki+comparison.png"
    }
  }, [_vm._v("the design here")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://www.dropbox.com/sh/lfrn4lcjyqhou7o/AAAmzec_63b1UwaZCGFDw1gea?dl=0&preview=Wiki+Selector.png",
      "target": "_new"
    }
  }, [_vm._v("here")]), _vm._v(".\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ui icon button",
    attrs: {
      "title": "Download"
    }
  }, [_c('i', {
    staticClass: "download icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_vm._v("\n            All Metrics\n            "), _c('div', {
    staticClass: "subdued"
  }, [_vm._v("Select a metric to visualize and explore its data")])])
}]}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.data.breakdowns && _vm.data.breakdowns[0].on) ? _c('span', _vm._l((_vm.data.breakdowns[0].values), function(b, i) {
    return (b.on) ? _c('span', [_c('span', {
      staticClass: "color swatch",
      style: ({
        'background-color': _vm.colors[_vm.ci[b.name]]
      })
    }), _vm._v("\n            " + _vm._s(b.name) + "\n        ")]) : _vm._e()
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "widget column",
    attrs: {
      "to": _vm.area + '/' + _vm.metric.name
    }
  }, [(_vm.metricData.type === 'bars') ? _c('metric-bar-widget', {
    attrs: {
      "data": _vm.metricData
    }
  }) : (_vm.metricData.type === 'lines') ? _c('metric-line-widget', {
    attrs: {
      "data": _vm.metricData
    }
  }) : (_vm.metricData.type === 'list') ? _c('metric-list-widget', {
    attrs: {
      "data": _vm.metricData
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('i', {
    staticClass: "ui globe icon"
  }), _vm._v("\n    Choose your preferred language\n    "), _c('div', {
    staticClass: "ui simple dropdown right labeled icon button"
  }, [_c('span', [_vm._v("Cantonese")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("English")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("French")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Cantonese")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("Arabic")])]), _vm._v(" "), _c('i', {
    staticClass: "ui dropdown icon"
  })])])
}]}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.minimized) ? _c('div', {
    staticClass: "spacer"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "top left"
  }, [_c('div', [(_vm.minimized) ? _c('span', {
    staticClass: "ui grey icon corner button",
    on: {
      "click": function($event) {
        _vm.minimized = false
      }
    }
  }, [_c('i', {
    staticClass: "ui info circle icon"
  }), _vm._v("\n                Explore Topics\n                "), _c('i', {
    staticClass: "ui chevron right icon"
  })]) : _vm._e()]), _vm._v(" "), (!_vm.minimized) ? _c('div', {
    staticClass: "ui grey inverted segment"
  }, [_c('i', {
    staticClass: "ui info circle icon"
  }), _vm._v("\n            Explore Topics\n            "), _c('div', {
    staticClass: "ui simple dropdown right labeled search icon button"
  }, [(!_vm.selectedQuestion) ? _c('span', {
    staticClass: "subdued"
  }, [_vm._v("Find questions you are interested in and click Go for the answers")]) : _vm._e(), _vm._v(" "), (_vm.selectedQuestion) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.selectedQuestion.q) + "\n                    "), _c('span', {
    staticClass: "subdued"
  }, [_vm._v("metric: " + _vm._s(_vm.selectedQuestion.m))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('h4', [_vm._v("Contributing")]), _vm._v(" "), _vm._l((_vm.contributingQuestions), function(q) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectQuestion(q)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(q.q) + " "), _c('span', {
      staticClass: "subdued"
    }, [_vm._v("metric: " + _vm._s(q.m))])])
  }), _vm._v(" "), _c('h4', [_vm._v("Reading")]), _vm._v(" "), _vm._l((_vm.readingQuestions), function(q) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectQuestion(q)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(q.q) + " "), _c('span', {
      staticClass: "subdued"
    }, [_vm._v("metric: " + _vm._s(q.m))])])
  }), _vm._v(" "), _c('h4', [_vm._v("Content")]), _vm._v(" "), _vm._l((_vm.contentQuestions), function(q) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectQuestion(q)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(q.q) + " "), _c('span', {
      staticClass: "subdued"
    }, [_vm._v("metric: " + _vm._s(q.m))])])
  }), _vm._v(" "), _c('h4', [_vm._v("More")]), _vm._v(" "), _vm._l((_vm.moreQuestions), function(q) {
    return _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.selectQuestion(q)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(q.q) + " "), _c('span', {
      staticClass: "subdued"
    }, [_vm._v("metric: " + _vm._s(q.m))])])
  })], 2), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ui blue button",
    on: {
      "click": _vm.go
    }
  }, [_vm._v("Go")]), _vm._v(" "), _c('span', {
    staticClass: "right floated"
  }, [_c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.minimized = true
      }
    }
  }, [_c('i', {
    staticClass: "ui left chevron icon"
  })])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ui three column centered grid"
  }, [_c('div', {
    staticClass: "middle aligned column"
  }, [_c('p', [_vm._v("Find out more "), _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("about Wikistats")]), _vm._v(" and the "), _c('router-link', {
    attrs: {
      "to": "/about-data"
    }
  }, [_vm._v("data that it uses")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "middle aligned column"
  }, [_c('p', [_vm._v("Wikistats is written with "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "//vuejs.org"
    }
  }, [_vm._v("Vue.js")]), _vm._v(" and "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "//semantic-ui.com"
    }
  }, [_vm._v("Semantic UI")]), _vm._v(".  If you'd like to contribute, see our "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "//wikitech.wikimedia.org/wiki/Analytics/Wikistats2.0"
    }
  }, [_vm._v("contributing guide")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "middle aligned column"
  }, [_c('p', [_vm._v("Wikistats is designed by "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "//aislinngrigas.com/about/"
    }
  }, [_vm._v("Aislinn Grigas")]), _vm._v(".")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "eight wide middle aligned column"
  }, [_c('p', [_vm._v("To the extent possible under law, The Wikimedia Foundation has waived all copyright and related or neighboring rights the data and charts on this site.")])])])
}]}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui medium statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.data.fullName))]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("kmb")(_vm.data.lastMonthValue)))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "subdued"
  }, [_vm._v(_vm._s(_vm.data.lastMonth))]), _vm._v(" "), _c('span', {
    staticClass: "change label"
  }, [_c('arrow-icon', {
    attrs: {
      "value": _vm.data.changeMoM
    }
  }), _vm._v("\n            " + _vm._s(_vm.data.changeMoM) + " % month over month\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bar-chart"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui horizontal small statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n            " + _vm._s(_vm._f("kmb")(_vm.data.lastYearValue)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "change label"
  }, [_c('arrow-icon', {
    attrs: {
      "value": _vm.data.changeYoY
    }
  }), _vm._v("\n            " + _vm._s(_vm.data.changeYoY) + " % year over year\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "year total subdued"
  }, [_vm._v("\n        Year Total (" + _vm._s(_vm.data.lastYear) + ")\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui medium statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.data.fullName))]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("kmb")(_vm.data.lastMonthValue)))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "subdued"
  }, [_vm._v(_vm._s(_vm.data.lastMonth))]), _vm._v(" "), _c('span', {
    staticClass: "change label"
  }, [_c('arrow-icon', {
    attrs: {
      "value": _vm.data.changeMoM
    }
  }), _vm._v("\n            " + _vm._s(_vm.data.changeMoM) + " % month over month\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line-chart"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui horizontal small statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n            " + _vm._s(_vm._f("kmb")(_vm.data.lastYearValue)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "change label"
  }, [_c('arrow-icon', {
    attrs: {
      "value": _vm.data.changeYoY
    }
  }), _vm._v("\n            " + _vm._s(_vm.data.changeYoY) + " % year over year\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "year total subdued"
  }, [_vm._v("\n        Year Total (" + _vm._s(_vm.data.lastYear) + ")\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    The map chart "), _c('i', {
    staticClass: "ui globe chart icon"
  }), _vm._v(" is not implemented in the prototype.  You can see how it will look in "), _c('a', {
    attrs: {
      "target": "_new",
      "href": "https://www.dropbox.com/sh/lfrn4lcjyqhou7o/AAAmzec_63b1UwaZCGFDw1gea?dl=0&preview=Detail+Page+Country+Breakdown.png"
    }
  }, [_vm._v("the design here")]), _vm._v(".\n")])
}]}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big bar chart"
  })
},staticRenderFns: []}

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big line chart"
  })
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('h1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warning),
      expression: "warning"
    }],
    staticClass: "ui red header"
  }, [_vm._v("PROTOTYPE: Only tested in Chrome, No real data, \"Loading Delay\" is fake, This is a WORK IN PROGRESS")]), _vm._v(" "), _c('section', {
    staticClass: "ui top attached clearing segment"
  }, [_c('top-nav')], 1), _vm._v(" "), _c('section', {
    staticClass: "ui attached content segment"
  }, [_c('topic-explorer'), _vm._v(" "), _c('router-view', {
    attrs: {
      "wiki": _vm.wiki
    },
    on: {
      "wiki": _vm.wikiSelected
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "ui attached language segment"
  }, [_c('site-language')], 1), _vm._v(" "), _c('section', {
    staticClass: "ui attached footer segment"
  }, [_c('bottom-footer')], 1)])
},staticRenderFns: []}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui right floated link header"
  }, _vm._l((_vm.areas), function(a) {
    return _c('router-link', {
      key: a.name,
      attrs: {
        "to": a.path
      }
    }, [_vm._v("\n            " + _vm._s(a.name) + "\n        ")])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "ui left floated title header"
  }, [_c('span', {
    staticClass: "ui mini image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(362)
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Wikimedia Statistics")])])
}]}

/***/ }),
/* 394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui medium statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.data.fullName))])]), _vm._v(" "), _c('div', {
    staticClass: "subdued"
  }, [_vm._v("\n        " + _vm._s(_vm.data.valueName) + "\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "widget list"
  }, _vm._l((_vm.formattedList), function(line, index) {
    return _c('li', [_c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(line.value))]), _vm._v("\n             \n            "), (_vm.data.showNumbers) ? _c('span', [_vm._v(_vm._s(index + 1) + ".")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v("\n                " + _vm._s(_vm._f("elipsis")(line.name, 17)) + "\n            ")])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span')
},staticRenderFns: []}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "widgets"
  }, [_c('div', {
    staticClass: "ui clearing basic top segment"
  }, [_c('h2', {
    staticClass: "ui left floated header"
  }, [_vm._v("Monthly Overview")]), _vm._v(" "), _c('h5', {
    staticClass: "ui right floated header"
  }, [_c('wiki-selector', {
    attrs: {
      "wiki": _vm.wiki,
      "single": "true"
    },
    on: {
      "wiki": _vm.wikiSelected
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.areas), function(a) {
    return _c('div', {
      key: a.state.id,
      staticClass: "ui basic area segment"
    }, [_c('dashboard-area', {
      attrs: {
        "area": a.state
      }
    })], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "ui arrow icon",
    class: {
      up: parseFloat(_vm.value) > 0,
        down: parseFloat(_vm.value) < 0
    }
  })
},staticRenderFns: []}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.breakdown) ? _c('table', {
    staticClass: "ui table",
    class: _vm.data.area
  }, [_c('thead', [(_vm.data.type === 'bars') ? _c('tr', [_c('th', [_vm._v("Month")]), _vm._v(" "), _c('th', [_vm._v("Total")])]) : _vm._e(), _vm._v(" "), (_vm.data.type === 'list') ? _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.data.valueName))])]) : _vm._e()]), _vm._v(" "), _c('tbody', [_vm._l((_vm.data.detail), function(m) {
    return (_vm.data.type === 'bars') ? _c('tr', [_c('td', [_vm._v(_vm._s(m.month))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.total))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.data.sortedList), function(m) {
    return (_vm.data.type === 'list') ? _c('tr', [_c('td', [_vm._v(_vm._s(m.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.value))])]) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.breakdown) ? _c('table', {
    staticClass: "ui table",
    class: _vm.data.area
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Month")]), _vm._v(" "), _vm._l((_vm.breakdown.values), function(v) {
    return (v.on) ? _c('th', [_vm._v(_vm._s(v.name))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.detail), function(m) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(m.month))]), _vm._v(" "), _vm._l((_vm.breakdown.values), function(v) {
      return (v.on) ? _c('td', [_vm._v(_vm._s(m.breakdowns[_vm.breakdown.name][v.name]))]) : _vm._e()
    })], 2)
  }))]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui search"
  }, [_c('div', {
    staticClass: "ui icon input"
  }, [_c('input', {
    staticClass: "prompt",
    attrs: {
      "type": "text",
      "placeholder": _vm.single ? 'Choose a Wiki' : 'Add another Wiki'
    },
    domProps: {
      "value": _vm.wiki
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "search icon"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui buttons",
    attrs: {
      "title": "Not Prototyped"
    }
  }, [_c('button', {
    staticClass: "ui button"
  }, [_vm._v("All")]), _vm._v(" "), _c('button', {
    staticClass: "ui active button"
  }, [_vm._v("2-Year")]), _vm._v(" "), _c('button', {
    staticClass: "ui button"
  }, [_vm._v("1-Year")]), _vm._v(" "), _c('button', {
    staticClass: "ui button"
  }, [_vm._v("3-Month")]), _vm._v(" "), _c('button', {
    staticClass: "ui button"
  }, [_vm._v("1-Month")])])
}]}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "area",
    class: _vm.area.id
  }, [_c('div', {
    staticClass: "ui top attached header"
  }, [_vm._v("\n        " + _vm._s(_vm.area.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui attached basic segment"
  }, [_c('div', {
    staticClass: "ui three column grid"
  }, _vm._l((_vm.area.metrics), function(m) {
    return _c('metric-widget', {
      key: m,
      attrs: {
        "metric": {
          name: m
        },
        "area": _vm.area.id
      }
    })
  }))])])
},staticRenderFns: []}

/***/ }),
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('thousands', function (n) {
    return __WEBPACK_IMPORTED_MODULE_3_numeral__(n).format('0,0');
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('kmb', function (n) {
    return __WEBPACK_IMPORTED_MODULE_3_numeral__(n).format('0.0a');
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('elipsis', function (n, l) {
    return n.substring(0, l) + (l <= n.length ? '...' : '');
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })
],[405]);


// WEBPACK FOOTER //
// static/js/app.ae0abc7d8e843c1e12b0.js